import { render, staticRenderFns } from "./GreenLocationForm.vue?vue&type=template&id=2beee4e9&scoped=true&"
import script from "./GreenLocationForm.vue?vue&type=script&lang=js&"
export * from "./GreenLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beee4e9",
  null
  
)

export default component.exports